
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from 'vue-property-decorator';

@Component
export default class ModalTermConditionComponent extends Vue {
  @Prop() public show: boolean;

  constructor() {
    super();
  }

  @Emit('agree') private clickAgree() {
    this.$emit('update:show', false);
  }
}
